var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root"},[_c('div',{staticClass:"uk-margin-small-right"},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")]),_vm._v("\n        화면배율: "+_vm._s(_vm.screenRatioText)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }